import React from 'react';
import {
  Layout,
  Card,
  withTranslation,
} from '@piwikpro/ui-components';
import TitleComponent from '@piwikpro/title-crate/Title';
import { TFunction } from 'react-i18next';
import { errorBoundary, withInject } from '@piwikpro/platform';

import GeneralTimezoneAndCurrency from './GeneralTimezoneAndCurrency';
import Integrations from './Integrations';
import Apps from './Apps';

interface InjectedProps {
  Title: typeof TitleComponent
}

interface Props extends InjectedProps{
  t: TFunction
}

class Settings extends React.Component<Props> {
  render() {
    const {
      t,
      Title,
    } = this.props;

    return (
      <Title part={t('meta-sites.details.tabs.settings')}>
        <Layout>
          <Layout.AnnotatedSection
            title={t('meta-sites.details.settings.general.title')}
          />
          <Layout.Column dominant>
            <Card>
              <Card.Section>
                <GeneralTimezoneAndCurrency />
              </Card.Section>
            </Card>
          </Layout.Column>
        </Layout>
        <Layout>
          <Layout.AnnotatedSection
            title={t('apps.details.settings.integrations.title')}
          />
          <Layout.Column dominant>
            <Integrations />
          </Layout.Column>
        </Layout>
        <Layout>
          <Layout.AnnotatedSection
            title={t('meta-sites.details.settings.appsList.title')}
          />
          <Layout.Column dominant>
            <Apps />
          </Layout.Column>
        </Layout>
      </Title>
    );
  }
}

export default withInject<InjectedProps>({
  Title: 'TitleCrate.components.Title',
})(
  withTranslation(['administration'])(errorBoundary(Settings)),
);
